
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $f46qz = parcelRequire("f46qz");

var $4iCXN = parcelRequire("4iCXN");
(function initCheckbox() {
    (0, $f46qz.onClickAll)('.checkbox', (event)=>{
        if (!(event.target.nodeName === 'A')) event.currentTarget.classList.toggle('checkbox_checked');
    });
})();
(function initBackBtn() {
    (0, $f46qz.onClickAll)('.behavior-go-back', ()=>{
        globalThis.history.go(-1);
    });
})();
(function initBtnGoHome() {
    (0, $f46qz.onClickAll)('.behavior-go-home', ()=>{
        globalThis.location.href = localStorage.getItem('home');
    });
})();
(function initBtnGoToCombos() {
    (0, $f46qz.onClickAll)('.behavior-go-combos', ()=>{
        (0, $4iCXN.redirectToPage).combos();
    });
})();


//# sourceMappingURL=addons.63d3501e.js.map
